import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iuf_select = _resolveComponent("iuf-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_iuf_select, _mergeProps({
      label: _ctx.label,
      options: _ctx.options,
      "option-label": "label",
      "option-value": "dobjId"
    }, _ctx.SELECT_SINGLE_LG, {
      modelValue: _ctx.groupModel,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.groupModel) = $event)),
        _ctx.onSelect
      ]
    }), null, 16, ["label", "options", "modelValue", "onUpdate:modelValue"])
  ]))
}